import { defineComponent as d, provide as n, createElementBlock as s, openBlock as i, normalizeClass as o, renderSlot as l } from "vue";
import { D as r } from "./DescriptionList.keys-BHlHYV6b.js";
var c = /* @__PURE__ */ ((e) => (e.Columns = "columns", e.Inline = "inline", e.Stacked = "stacked", e.SpaceBetween = "space-between", e))(c || {});
const p = ["data-variant"], f = /* @__PURE__ */ d({
  __name: "DescriptionList",
  props: {
    divide: { type: Boolean, default: !1 },
    variant: { default: "columns" }
  },
  setup(e) {
    const t = e;
    return n(r.key, { divide: t.divide, variant: t.variant }), (a, v) => (i(), s("dl", {
      "data-variant": t.variant,
      class: o(["stash-description-list tw-text-sm", {
        "tw-divide-y tw-divide-ice-200": t.divide
      }]),
      "data-test": "stash-description-list"
    }, [
      l(a.$slots, "default")
    ], 10, p));
  }
});
export {
  r as DESCRIPTION_LIST_INJECTION,
  c as DescriptionListVariant,
  f as default
};
//# sourceMappingURL=DescriptionList.js.map
